var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"change-locale":_vm.change_locale}})
}
var staticRenderFns = []

export { render, staticRenderFns }